import { render, staticRenderFns } from "./GasSeparator.vue?vue&type=template&id=0fbfeb2c&"
import script from "./GasSeparator.vue?vue&type=script&lang=js&"
export * from "./GasSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports